// 申报材料
import {Button, DatePicker, Descriptions, Form, Input, Space, Table} from "antd";
import {Typography} from 'antd';
import {gql, useMutation, useSubscription} from "@apollo/client";
import {useEffect, useState} from "react";
import dayjs from "dayjs";

const {Title} = Typography;
const {TextArea} = Input;

export default function Sbcl(props) {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');

    const logto = props.logto
    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };
    const [qymc, setQymc] = useState()
    const [fliter, setFliter] = useState({where: {mndsb: {server: {_eq: ''}}}})
    const [userId, setUserId] = useState('')
    const [xjsb, setXjsb] = useState(null)
    const [xgqyxx, setXgqyxx] = useState(null)
    const companyColumns = [
        {
            title: '企业名称',
            dataIndex: 'qymc',
            key: 'qymc',
        },
        {
            title: '统一社会信用代码',
            dataIndex: 'tyshxydm',
            key: 'tyshxydm',
        },
        {
            title: '成立时间',
            dataIndex: 'clsj',
            key: 'clsj',
            render: (_, recoder) => new Date(_).toLocaleDateString()
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(e) => {
                    handleChange(record.id)
                }}>选择</a>
            ),
        },
    ];
    const {data: companyData, loading: companyDataLoading} = useSubscription(
        gql`subscription MySubscription($where: company_bool_exp = {}) {
            company(where: $where) {
                clsj
                created_at
                id
                qymc
                tyshxydm
                updated_at
                qyjc
                qyjj
            }
        }`, {
            variables: fliter,
            shouldResubscribe: true
        },
    );
    const [update_company_by_pk] = useMutation(
        gql`
            mutation MyMutation($_set: company_set_input = {}, $id: uuid = "") {
                update_company_by_pk(pk_columns: {id: $id}, _set: $_set) {
                    id
                }
            }
        `);
    const {data: theCompanyData, loading: theCompanyDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            company(where: {id: {_eq: $id}}) {
                clsj
                created_at
                id
                qymc
                tyshxydm
                updated_at
                qyjc
                qyjj
            }
        }`, {
            variables: {id: value},
            shouldResubscribe: true
        },
    );
    const [insert_mndsb, {error}] = useMutation(gql`
        mutation MyMutation($year: Int = 10, $company: uuid = "") {
            insert_mndsb_one(object: {year: $year, company: $company}) {
                id
            }
        }
    `);
    const columns = [
        {
            title: '申报年度',
            dataIndex: 'year',
            key: 'year',
        },
        {
            title: '申报时间',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (_, record) => new Date(_).toLocaleString(),
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'action',
            render: (_, record) => (
                <a onClick={(event) => {
                    window.location.hash = '/sbnr?' + _
                }}>申报内容</a>
            ),
        },
    ];
    const {data: mndsbData, loading: mndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($company: uuid = "",$server:String="") {
            mndsb(where: {company: {_eq: $company},server: {_eq: $server}}, order_by: {created_at: desc}) {
                created_at
                company
                id
                year
                updated_at
            }
        }`, {
            variables: {company: value,server:userId},
            shouldResubscribe: true
        },
    );
    useEffect(()=>{
        logto.fetchUserInfo().then(userInfo=> {
            setFliter({where: {mndsb: {server: {_eq: userInfo.sub}}}})
            setUserId(userInfo.sub)
        })
    },[])
    return (<>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <label title={'企业 ID'} style={{width: '70px'}}>企业 ID：</label>
            <Input value={value} onChange={(e) => {
                handleChange(e.target.value)
            }}/>
        </div>
        <div style={{padding: '10px'}}></div>
        {(theCompanyData || {}).company && <>
            <Descriptions title="" bordered>
                <Descriptions.Item label="企业名称" span={2}>{theCompanyData.company[0].qymc}</Descriptions.Item>
                <Descriptions.Item label="企业简称" span={2}>{theCompanyData.company[0].qyjc}</Descriptions.Item>
                <Descriptions.Item label="统一社会信用代码"
                                   span={2}>{theCompanyData.company[0].tyshxydm}</Descriptions.Item>
                <Descriptions.Item
                    label="成立时间"
                    span={2}>{new Date(theCompanyData.company[0].clsj).toLocaleDateString()}</Descriptions.Item>
                <Descriptions.Item label="企业简介"
                                   span={4}>{theCompanyData.company[0].qyjj}</Descriptions.Item>
                {/*<Descriptions.Item*/}
                {/*    label="操作" span={2}><Space>*/}
                {/*    <a onClick={() => {*/}
                {/*        setXjsb(theCompanyData.company[0].id)*/}
                {/*    }}>新建申报材料</a>*/}
                {/*    <a onClick={() => {*/}
                {/*        setXgqyxx(theCompanyData.company[0].id)*/}
                {/*    }}>修改企业信息</a></Space></Descriptions.Item>*/}
            </Descriptions>
            {xjsb && <>
                <div style={{padding: '10px'}}></div>
                <Form
                    name="basic"
                    labelCol={{
                        span: 32,
                    }}
                    wrapperCol={{
                        span: 32,
                    }}
                    style={{
                        maxWidth: 800,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    layout={'inline'}
                    onFinish={(e) => {
                        console.log(e.year.$y)
                        insert_mndsb({variables: {year: e.year.$y, company: theCompanyData.company[0].id}})
                    }}
                    onFinishFailed={(e) => {
                        console.error(e)
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="新建申报材料年度"
                        name="year"
                    >
                        <DatePicker picker="year"/>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 8, span: 8}}>
                        <Button type="primary" htmlType="submit">
                            确定
                        </Button>
                    </Form.Item>
                </Form>
            </>}
            {xgqyxx && <>
                <div style={{padding: '10px'}}></div>
                <Form
                    name="basic"
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    style={{maxWidth: 600}}
                    initialValues={{
                        ...(theCompanyData || {company: [{}]}).company[0],
                        clsj: dayjs(new Date((theCompanyData || {company: [{}]}).company[0].clsj))
                    }}
                    onFinish={(values) => {
                        update_company_by_pk({
                                variables: {
                                    id: (theCompanyData || {company: [{}]}).company[0].id,
                                    _set: {
                                        ...values,
                                        'clsj': values['clsj'].toDate()
                                    }
                                }
                            }
                        )
                    }
                    }
                    onFinishFailed={(e) => {
                        console.error(e)
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="企业名称"
                        name="qymc"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <Input placeholder="例如：桂林伯爵电子科技有限公司"/>
                    </Form.Item>
                    <Form.Item
                        label="企业简称"
                        name="qyjc"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <Input placeholder="例如：伯爵"/>
                    </Form.Item>
                    <Form.Item
                        label="统一社会信用代码"
                        name="tyshxydm"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <Input placeholder="例如：91450303MA5NUK7T7B"/>
                    </Form.Item>
                    <Form.Item
                        label="成立时间"
                        name="clsj"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <DatePicker/>
                    </Form.Item>

                    <Form.Item
                        label="企业简介"
                        name="qyjj"
                        rules={[{required: true, message: '请输入内容'}]}
                    >
                        <TextArea showCount autoSize={{
                            minRows: 5,
                        }}
                                  placeholder="例如：桂林伯爵电子科技有限公司成立于2019年，是一家致力于研发、生产、销售电子产品的高科技企业。公司拥有一支高素质的研发团队，致力于为客户提供一流的电子产品及解决方案。公司总部位于中国广西桂林市，拥有先进的制造和测试设施。旗下产品线包括智能家居、智能手表、智能手机等多个领域。公司以不断创新的理念为支撑，率先运用人工智能、区块链等新兴科技，不断推陈出新，不断创造优秀的产品和作品。公司注重品质和服务，拥有完善的质量控制系统，生产出来的产品质量可靠，深受用户好评。公司始终秉承“以人为本、诚信共赢”的经营理念，注重员工发展与客户需求的平衡，以满足客户需求为己任，服务社会，是广大消费者值得信赖的品牌。"/>
                    </Form.Item>

                    <Form.Item wrapperCol={{offset: 8, span: 16}}>
                        <Button type="primary" htmlType="submit">
                            确定
                        </Button>
                    </Form.Item>
                </Form>
            </>}
            <div style={{padding: '10px'}}></div>
            <Table columns={columns} dataSource={(mndsbData || []).mndsb}/>
        </>}
        <Title level={3}>筛选</Title>
        <Form
            name="basic"
            labelCol={{
                span: 32,
            }}
            wrapperCol={{
                span: 32,
            }}
            style={{
                maxWidth: 800,
            }}
            initialValues={{
                remember: true,
            }}
            layout={'inline'}
            onFinish={(e) => {

                const obj = {mndsb: {server: {_eq: '1'}}}
                // setFliter({})
                Object.keys(e).forEach(key => {
                    if (e[key])
                        obj[key] = {_ilike: `%${e[key]}%`}
                })
                // console.log(obj)
                setFliter({
                    where: {...obj}
                })
                console.log(fliter)
            }}
            onFinishFailed={(e) => {
                console.error(e)
            }}
            autoComplete="off"
        >
            <Form.Item
                label="企业名称"
                name="qymc"
            >
                <Input/>
            </Form.Item>
            <Form.Item
                label="统一社会信用代码"
                name="tyshxydm"
            >
                <Input/>
            </Form.Item>
            <Form.Item wrapperCol={{offset: 8, span: 8}}>
                <Button type="primary" htmlType="submit">
                    确定
                </Button>
            </Form.Item>
        </Form>
        <div style={{padding: '10px'}}></div>
        <Table columns={companyColumns} dataSource={(companyData || []).company}/>
    </>)
}
